export default __webpack_public_path__ + "static/media/avito.41edbe85.svg";